/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { combineReducers } from "redux";
import loginReducer from "../pages/login/ducks/slices";
import sidebarReducer from "../reducers/slices/sidebarSlice";
import errorSlice from "../reducers/slices/errorSlice";
import layoutSlice from "../reducers/slices/layoutSlice";
import studyReducer from "../pages/study/ducks/studySlice";
import signUpSlice from "../pages/signup/ducks/slices";
import userReducer from "../pages/admin/user/ducks/userSlice";
import settingAccountReducer from "../pages/settingAccount/ducks/slices";
import roleReducer from "../pages/admin/user/roles/ducks/slices";
import notificationReducer from "../components/Notification/ducks/notificationSlice";
import customerPACSReducer from "../pages/customerPACS/ducks/customerPACSSlice";

import responsiveReducer from "../reducers/slices/responsiveSlice";
import webAuthnSettingReducer from "../pages/userSetting/WebAuthnDevices/ducks/slices";
import trustedDevicesReducer from "../pages/userSetting/TrustedDevices/ducks/slices";
import securitySettingReducer from "../pages/admin/setting/security/ducks/slice";
import profileReducer from "../pages/userSetting/ducks/profileSlice";
import samlConfigurationReducer from "../pages/admin/setting/authentication/saml/ducks/slice";
import settingGeneralReducer from "../pages/admin/setting/ducks/slices";
import countryReducer from "../reducers/slices/countrySlice";
import instructionReducer from "../reducers/slices/instructionSlice";
import eulaReducer from "../reducers/slices/eulaSlice";
import criticalResultReducer from "../pages/criticalResult/ducks/slices";
import diagnosticReportReducer from "../reducers/slices/diagnosticReportSlice";

const rootReducer = combineReducers({
  // 👆🏻 Alphabetically sorted
  countryReducer,
  customerPACSReducer,
  diagnosticReportReducer,
  errorSlice,
  layoutSlice,
  loginReducer,
  notificationReducer,
  profileReducer,
  responsiveReducer,
  roleReducer,
  samlConfigurationReducer,
  securitySettingReducer,
  settingAccountReducer,
  settingGeneralReducer,
  sidebarReducer,
  signUpSlice,
  studyReducer,
  trustedDevicesReducer,
  userReducer,
  webAuthnSettingReducer,
  instructionReducer,
  eulaReducer,
  criticalResultReducer,
});

export type IRootState = ReturnType<typeof rootReducer>;
export default rootReducer;
